/* eslint-disable quotes, quote-props, comma-dangle  */
import type { TranslationProps } from './types';

export const translations = {
  "cancel_button_label": [
    {
      "type": 0,
      "value": "Avbryt"
    }
  ],
  "warning_body_list_item_one": [
    {
      "type": 0,
      "value": "Du har erhållit ett affärsmässigt berättigande för åtkomst till kunddata"
    }
  ],
  "warning_body_list_item_two": [
    {
      "type": 0,
      "value": "Dina nedladdningsaktiviteter kommer att registreras och spåras i syfte att kontrollera deras säkerhetsefterlevnad"
    }
  ],
  "warning_footer": [
    {
      "type": 0,
      "value": "Vill du fortsätta?"
    }
  ],
  "warning_header": [
    {
      "type": 0,
      "value": "Genom att ladda ned bekräftar du att:"
    }
  ]
};

function TranslationProviderComponent({ children }: TranslationProps) {
  return children(translations);
}

export default Object.assign(TranslationProviderComponent, { translations });
